"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function validate(candidate) {
    if (!candidate.hasOwnProperty('key')) {
        return false;
    }
    if (candidate.key === '') {
        return false;
    }
    if (!candidate.hasOwnProperty('value')) {
        return false;
    }
    return true;
}
exports.validate = validate;
function validateConfig(config) {
    if (!Array.isArray(config)) {
        throw new Error("Config should be an array of settings. Instead loaded " + JSON.stringify(config, null, 2));
    }
    config.forEach(function (setting) {
        if (!validate(setting)) {
            throw new Error("Failed to validate setting: " + JSON.stringify(setting, null, 4));
        }
    });
}
exports.validateConfig = validateConfig;
//# sourceMappingURL=validation.js.map